module.exports = __webpack_public_path__ + "img/org.87d42915.png";